import type { ReactNode } from "react";
import { Ico } from "./shell";
import { AtlModalOverlay, AtlModalShell, SparkleIcon } from "./atelier";

/* Two-option chooser shown when "Create Quiz" is clicked on the Quizzes tab:
   generate with AI (opens AiModal) or start a blank quiz in the builder. */
export default function NewQuizModal({
  onClose,
  onPickAI,
  onPickManual,
}: {
  onClose: () => void;
  onPickAI: () => void;
  onPickManual: () => void;
}) {
  return (
    <AtlModalOverlay onClose={onClose}>
      <AtlModalShell
        icon={<Ico name="plus" size={22} />}
        iconBg="var(--atl-accent)"
        iconFg="#fff"
        title="New quiz"
        sub="How do you want to start?"
        onClose={onClose}
      >
        <div style={{ display: "flex", gap: 14, marginTop: 18, flexWrap: "wrap" }}>
          <Choice
            onClick={onPickAI}
            iconBg="var(--atl-gold-soft)"
            iconFg="var(--atl-gold)"
            icon={<SparkleIcon size={26} />}
            title="Generate with AI"
            sub="Draft questions from a topic, or a PDF / PowerPoint you upload."
          />
          <Choice
            onClick={onPickManual}
            iconBg="#fbf2f3"
            iconFg="var(--atl-accent)"
            icon={<Ico name="build" size={26} />}
            title="Create manually"
            sub="Start from a blank quiz and write your own questions."
          />
        </div>
      </AtlModalShell>
    </AtlModalOverlay>
  );
}

function Choice({
  onClick,
  icon,
  iconBg,
  iconFg,
  title,
  sub,
}: {
  onClick: () => void;
  icon: ReactNode;
  iconBg: string;
  iconFg: string;
  title: string;
  sub: string;
}) {
  return (
    <div
      className="atl-card"
      onClick={onClick}
      style={{ flex: "1 1 200px", minWidth: 200, padding: 20, display: "flex", flexDirection: "column", gap: 14, cursor: "pointer" }}
    >
      <span style={{ width: 52, height: 52, borderRadius: 15, background: iconBg, color: iconFg, display: "grid", placeItems: "center" }}>
        {icon}
      </span>
      <div>
        <div className="atl-serif" style={{ fontSize: 17 }}>{title}</div>
        <div style={{ fontSize: 12.5, color: "var(--atl-soft)", fontWeight: 500, marginTop: 3, lineHeight: 1.4 }}>{sub}</div>
      </div>
    </div>
  );
}
